module.exports = __webpack_public_path__ + "ec80feee09097c887cdfd52a1d6cff45.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/news/img1_3.jpg
// module id = 288
// module chunks = 0